export const TikTokIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M16.7083 -0.0229492H12.6636V16.3249C12.6636 18.2727 11.1079 19.8727 9.17201 19.8727C7.23608 19.8727 5.68043 18.2727 5.68043 16.3249C5.68043 14.4119 7.20151 12.8466 9.06832 12.7771V8.67272C4.95446 8.74225 1.63574 12.1162 1.63574 16.3249C1.63574 20.5684 5.0236 23.9771 9.20659 23.9771C13.3895 23.9771 16.7774 20.5336 16.7774 16.3249V7.94225C18.2985 9.05532 20.1652 9.71618 22.1357 9.75098V5.64662C19.0936 5.54227 16.7083 3.03792 16.7083 -0.0229492Z"
            fill="currentColor"
        />
    </svg>
);
